import { RegionShared } from "@1games-ru/region-shared";
import { BankFilialShowRequest } from "@1games-ru/region-shared/dist/cef/requests/bank";
import { useCallback, useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import GameMpProvider from "@/core/data-provider/data-mp/game/game-mp-provider";

export function useShowBankBranch() {
  const [isOpen, setIsOpen] = useState(false);
  const [filialId, setFilialId] = useState<number | null>(null);

  const close = useCallback(() => {
    GameMpProvider.closeCurrentInterface(true);
  }, []);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Bank.BankFilialShow, (response: BankFilialShowRequest) => {
      setIsOpen(true);
      setFilialId(response.filialId);
    });

    rpc.register(RegionShared.Cef.Events.Bank.BankFilialHide, () => setIsOpen(false));

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Bank.BankFilialShow);
      rpc.unregister(RegionShared.Cef.Events.Bank.BankFilialHide);
    };
  }, []);

  return { isOpen, close, filialId };
}
